import React, { useEffect, useState } from 'react';
import { styles as st } from './Layout';

export default function Notificaciones({ onAbrirCliente }) {
  const [tareas, setTareas] = useState([]);

  const load = () => fetch('/api/notificaciones').then((r) => r.json()).then(setTareas);
  useEffect(() => { load(); }, []);

  const hoy = new Date().toISOString().slice(0, 10);

  return (
    <div style={st.card}>
      <h2 style={st.sectionTitle}>Notificaciones — tareas pendientes</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 12 }}>
        <thead>
          <tr>
            <th style={st.th}>Cliente</th>
            <th style={st.th}>Broker</th>
            <th style={st.th}>Descripción</th>
            <th style={st.th}>Fecha programada</th>
            <th style={st.th}></th>
          </tr>
        </thead>
        <tbody>
          {tareas.map((t) => (
            <tr key={t.id}>
              <td style={st.td}>{t.nombre_cliente}</td>
              <td style={st.td}>{t.broker_nombre}</td>
              <td style={st.td}>{t.descripcion}</td>
              <td style={{ ...st.td, color: String(t.fecha_programada).slice(0, 10) < hoy ? '#dc2626' : '#111827', fontWeight: String(t.fecha_programada).slice(0, 10) < hoy ? 700 : 400 }}>
                {String(t.fecha_programada).slice(0, 10)}{String(t.fecha_programada).slice(0, 10) < hoy ? ' (vencida)' : ''}
              </td>
              <td style={st.td}>
                <button style={st.btnAccent} onClick={() => onAbrirCliente(t.cliente_id)}>Ver expediente</button>
              </td>
            </tr>
          ))}
          {tareas.length === 0 && (
            <tr><td style={st.td} colSpan={5}>No hay tareas pendientes.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
